export default __webpack_public_path__ + "static/media/Belt of Black Oblivion.4680f43f.jpg";